const { defer } = rxjs;
const { filter, mapTo, publish, refCount } = rxjs.operators;

export default class Handle {
  constructor(session, handle, qClass) {
    this.session = session;
    this.handle = handle;
    this.qClass = qClass;

    this.invalidated$ = session.changes$.pipe(
      filter(f => f.indexOf(handle) > -1),
      mapTo(this),
      publish(),
      refCount()
    );
  }

  ask(method, ...args) {
    return defer(() =>
      this.session.ask({
        method: method,
        handle: this.handle,
        params: args.filter(arg => typeof arg !== "undefined"),
        qClass: this.qClass
      })
    );
  }
}
